<template>
  <v-toolbar color="panel" dark window class="notes__header">
    <v-tooltip top>
      <v-btn small outline slot="activator" color="white" @click="goToTodayDate()">Сегодня</v-btn>
      <span>Перейти к сегодняшней дате</span>
    </v-tooltip>
    <v-tooltip top>
      <v-switch
        hide-details
        slot="activator"
        label="Дни с заметками"
        v-model="showFullNotes"
        class="mb-1"
      ></v-switch>
      <span>Режим отображения заметок</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-tooltip top class="mr-2">
      <v-icon @click="toggleEditorTools" slot="activator">keyboard</v-icon>
      <span>{{ showEditorTools ? 'Скрыть панель инструментов' : 'Открыть панель инструментов'}}</span>
    </v-tooltip>
    <v-tooltip top>
      <v-btn @click="toggleDatePickerVisibility()" small icon slot="activator" class="mx-0">
        <v-icon class="mx-0">date_range</v-icon>
      </v-btn>
      <span>Выбрать дату</span>
    </v-tooltip>
    <v-tooltip top>
      <v-btn
        @click="searchInit()"
        small
        icon
        slot="activator"
        class="mx-0"
      >
        <v-icon class="mx-0">search</v-icon>
      </v-btn>
      <span>Поиск</span>
    </v-tooltip>
    <v-tooltip top class="notes__header__calendarSync">
      <v-btn small icon slot="activator" class="mx-0" @click="toggleCalendarSync()">
        <v-icon :class="`calendarSync__Link ${calendarSync ? '' : '-disabled'}`">link</v-icon>
      </v-btn>
      <span v-if="!calendarSync">Включить синхронизацию с календарем</span>
      <span v-else>Выключить синхронизацию с календарем</span>
    </v-tooltip>
    <v-tooltip top class="notes__header__calendarSync">
      <v-btn small icon slot="activator" class="mx-0" @click="expandNotes()">
        <v-icon>{{ expandPanel ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</v-icon>
      </v-btn>
      <span v-if="!expandPanel">Скрыть календарь </span>
      <span v-else>Показать календарь</span>
    </v-tooltip>
  </v-toolbar>
</template>
<script>
export default {
  name: 'NotesHeader',
  props: {},
  data() {
    return {
      showFullNotes: false,
      datePickerVisible: false,
      searchNotesVisible: false,
      calendarSync: true,
      showEditorTools: true,
      expandPanel: false
    };
  },
  methods: {
    expandNotes() {
      this.expandPanel = !this.expandPanel
      this.$bus.$emit('expandNotes', this.expandPanel)
    },
    toggleEditorTools() {
      this.showEditorTools ? this.showEditorTools = false : this.showEditorTools = true
      this.$bus.$emit('toggleEditorTools', this.showEditorTools)
    },
    toggleDatePickerVisibility() {
      this.datePickerVisible
        ? (this.datePickerVisible = false)
        : (this.datePickerVisible = true);
      this.$bus.$emit('datePickerVisible', this.datePickerVisible);
    },
    goToTodayDate() {
      this.$bus.$emit('goToToday');
    },
    toggleCalendarSync() {
      this.calendarSync
        ? (this.calendarSync = false)
        : (this.calendarSync = true);
      this.$bus.$emit('calendarSync', this.calendarSync);
    },
    searchInit() {
      this.searchNotesVisible ? this.searchNotesVisible = false : this.searchNotesVisible = true
      this.$bus.$emit('searchInit',this.searchNotesVisible)
    }
  },
  watch: {
    showFullNotes: function(status) {
      this.$bus.$emit('showFullNotes', status)
    }
  },
  mounted() {
    this.$bus.$on('hideDatePicker', ()=>{
      this.datePickerVisible = false
    })
    this.$bus.$on('hideSearchBlock', ()=>{
      this.searchNotesVisible = false
    })
    this.$bus.$on('showNotesWithFakes', ()=>{
      this.showFullNotes = false
    })
    // 
    // this.$bus.$emit('calendarSync', this.calendarSync);
  },
  destroyed() {
    this.$bus.$off('hideDatePicker')
    this.$bus.$off('hideSearchBlock')
    this.$bus.$off('showNotesWithFakes')
  }
};
</script>
<style lang='scss'>

</style>




// WEBPACK FOOTER //
// src/apps/bpm/notes/components/notes/NotesHeader.vue